/* eslint-disable */
import { Autoplay, Navigation, Pagination, Controller, EffectFade } from "swiper";
import Swiper from "swiper";
import 'simplebar';
import ajaxExperts from "../src/ajaxExperts";
import menuMobile from "../src/menuMobile";
import Masonry   from 'masonry-layout';
import evermapsSearch from "../libs/evermaps/evermapsSearch";
Swiper.use([Autoplay, Navigation, Pagination, Controller, EffectFade]);


export default {
    init() {
        // JavaScript to be fired on all pages
        //
        $(function () {

            let scroll = $(window).scrollTop();
            let windowWidth = $(document).width();

            $(window).scroll(function () {
                scroll = $(window).scrollTop();
                posHeader();
            });

            $(window).resize(function () {
                windowWidth = $(document).width();
            });

            // Blur on click
            $('a, button, input[type=\'submit\'], .btn').on('click', function () {
                $(this).blur();
            });





            // ========================================
            // Header
            // ========================================
            // Push app mobile
            $('.js_close-push-app-mobile').on('click', function() {
                $('.push-app-mobile').slideUp(400);
                document.cookie = 'push_app_closed=1; Secure';
            })


            // Notification message
            $('.js_close-notification-message').on('click', function() {
                $('.notification-message').slideUp(400);
                document.cookie = 'notification_closed=1; Secure';
            })


            // Search
            $('.js_toggle-form-search').on('click', function (e) {
                $('body').toggleClass('form-search-active');
                setTimeout(function () {
                    if ($('body').hasClass('form-search-active')) {
                        $('.form-search .search-field').focus();
                    }
                }, 100);
            });


            // Navigation mobile
            $('.js_toggle-nav-mobile').on('click', function () {
                $('body').toggleClass('nav-mobile-active');
                $('html').toggleClass('disable-scroll');
            });

            $(document).on('click', '.nav-mobile', function (e) {
                if (e.target !== this) {
                    return;
                }
                $('body').removeClass('nav-mobile-active');
                $('html').removeClass('disable-scroll');
            });

            $('#header .nav-mobile .menu > li.menu-item-has-children > a .icon').on('click', function () {
                $(this).closest('li').toggleClass('active');
                $(this).closest('a').next('.sub-menu').slideToggle(400);
            });


            // Position header mobile
            let position = $(window).scrollTop();
            let keepHeaderVisible = false;
            let headerSticky = 0;
            let $header = $('#header');
            let headerHeight;
            let headerTop;

            function posHeader() {
                // console.log($header, $('#header'));
                // if ($header.length == 0) return;
                
                headerHeight = $header.outerHeight(true);
                if (typeof $('#header').offset() !== 'undefined') {
                    headerTop = $('#header').offset().top;
                } else {
                    headerTop = 0;
                }

                if (scroll > 0) {
                    $('body').addClass('scroll');
                } else {
                    $('body').removeClass('scroll');
                }

                if (windowWidth <= 1024) {
                    if (scroll > position) {
                        // Scroll down
                        if (scroll > headerHeight) {
                            // Cache le header
                            headerSticky = headerHeight;
                            $header.addClass('transition');
                        } else {
                            if (!keepHeaderVisible) {
                                // Cache le header progressivement suivant le scroll
                                headerSticky = scroll;
                                $header.removeClass('transition');
                            }
                        }
                    } else {
                        // Scroll Up
                        if (scroll > headerHeight) {
                            // Affiche le header
                            headerSticky = 0;
                            $header.addClass('transition');
                            keepHeaderVisible = true; // Garde le header visible jusqu'en haut de page
                        } else if (keepHeaderVisible) {
                            headerSticky = 0;
                            $header.addClass('transition');
                        } else {
                            // Affiche le header progressivement suivant le scroll
                            headerSticky = scroll;
                            $header.removeClass('transition');
                            keepHeaderVisible = false; // Garde le header visible jusqu'en haut de page
                        }
                    }
                    if (scroll <= 0) {
                        headerSticky = 0;
                        keepHeaderVisible = false;
                    }

                    $header.css('transform', 'translateY(-' + headerSticky + 'px)');

                    position = scroll;
                } else {
                    $header.css('transform', '');
                }
            }
            posHeader();

            $('.btn-opinion').on('click', function() {
                console.log('click')
                CritizrSDK.open("modal:store_locator", null);
            });





            // ========================================
            // Popin
            // ========================================
            function openPopin(popin) {
                $('.popin-wrapper[data-popin="' + popin + '"]').show(0).addClass('active');
                $('html').addClass('disable-scroll');
            }

            function closePopin(popin) {
                $('.popin-wrapper').removeClass('active');
                setTimeout(function () {
                    $('html').removeClass('disable-scroll');
                    $('.popin-wrapper').hide(0);
                }, 600);
            }

            $(document).on('click', '.js_open-popin', function () {
                openPopin($(this).data('popin'), $(this).data('slide'));
            });


            $(document).on('click', '.js_close-popin', function () {
                closePopin();
            });
            $(document).on('click', '.popin-wrapper', function (e) {
                if (e.target !== this) {
                    return;
                }
                closePopin();
            });





            // ========================================
            // PAGES
            // ========================================
            // Single product
            function initSliderProduct2 (elt) {
                new Swiper(elt, {
                    loop: true,
                    speed: 750,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: '.slider-arrow-next',
                        prevEl: '.slider-arrow-prev',
                    },
                    breakpoints: {
                        481: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                        701: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        },
                        961: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                    },
                });
            }

            $('.js_slider-products2').each(function () {
                let elt = this;
                if ($(elt).find('.item').length > 3) {
                    initSliderProduct2(elt);
                } else if ($(elt).find('.item').length > 2) {
                    if ($(window).width() < 701 || $(window).width() > 960) {
                        initSliderProduct2(elt);
                    }
                } else if ($(elt).find('.item').length > 1) {
                    if ($(window).width() < 481 ) {
                        initSliderProduct2(elt);
                    }
                }
            });


            // Single tag
            $('.js_slider-products1').each(function () {
                let elt = this;
                if ($(elt).find('.item').length > 2) {
                    new Swiper(elt, {
                        loop: true,
                        speed: 750,
                        slidesPerView: 2,
                        spaceBetween: 40,
                        navigation: {
                            nextEl: '.slider-arrow-next',
                            prevEl: '.slider-arrow-prev',
                        },
                    });
                }
            });


            // Archive news
            if ($('.page-archive-news .content-primary .list-news').length > 0) {
                var masonry = new Masonry('.page-archive-news .content-primary .list-news', {
                    // options
                    itemSelector: '.item',
                    columnWidth: '.item',
                    gutter: 27,
                    percentPosition: true
                });
            }


            // Single news
            // Video
            $('.page-single-news-img-horizontal .js_play-video').on('click', function () {
                let $elt = $(this);
                let $iframe = $elt.closest('.illus-page-wrapper').find('iframe');
                $elt.closest('.illus-page-wrapper').addClass('video-active');
                $iframe[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                console.log($iframe);
                console.log($iframe[0]);
            });

            // Popin slideshow
            let sliderSlideshow = new Swiper('.js_slider-slideshow', {
                loop: true,
                speed: 750,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.slider-arrow-next',
                    prevEl: '.slider-arrow-prev',
                },
                pagination: {
                    el: '.slider-pager',
                    type: 'fraction',
                },
            });
            let sliderSlideshowText = new Swiper('.js_slider-txt-slideshow', {
                loop: true,
                speed: 750,
                effect: 'fade',
            });
            sliderSlideshowText.controller.control = sliderSlideshow;
            sliderSlideshow.controller.control = sliderSlideshowText;
            $('.js_slider-thumbnails').on('click', function () {
                let $elt = $(this);
                let indexSlide = $elt.data('slide');
                sliderSlideshow.slideTo(indexSlide);
            });


            // Contact
            $('.page-contact .js_toggle-form-desktop').on('click', function () {
                let $elt = $(this);
                if (!$elt.hasClass('active')) {
                    let nbrForm = $elt.data('form');
                    $('.js_toggle-form-desktop').removeClass('active');
                    $elt.addClass('active');
                    $('.module-form-wrapper').slideUp(400);
                    $('.module-form-wrapper[data-form="' + nbrForm + '"]').slideDown(400);
                }
            });
            $('.page-contact .js_toggle-form-mobile').on('change', function () {
                let $elt = $(this);
                let nbrForm = $elt.val();
                $('.module-form-wrapper').slideUp(400);
                $('.module-form-wrapper[data-form="' + nbrForm + '"]').slideDown(400);
            });


            // Archive services
            $('.js_anchor').each(function() {
                $(this).css('top', -$('#header').outerHeight(true));
            });





            // ========================================
            // MODULES
            // ========================================
            // Banner slider
            $('.js_slider-banner-slider').each(function () {
                let elt = this;
                if ($(elt).find('.item').length > 1) {
                    new Swiper(elt, {
                        loop: true,
                        speed: 750,
                        autoHeight: true,
                        autoplay: {
                            delay: 5000,
                        },
                        navigation: {
                            nextEl: '.slider-arrow-next',
                            prevEl: '.slider-arrow-prev',
                        },
                        pagination: {
                            el: '.slider-progression',
                            type: 'progressbar',
                        },
                    });
                }
            });


            // Products slider
            function initSliderProductsSlider (elt) {
                new Swiper(elt, {
                    loop: true,
                    speed: 750,
                    slidesPerView: 2,
                    spaceBetween: 40,
                    navigation: {
                        nextEl: '.slider-arrow-next',
                        prevEl: '.slider-arrow-prev',
                    },
                    breakpoints: {
                        601: {
                            slidesPerView: 3,
                            spaceBetween: 33
                        },
                        961: {
                            slidesPerView: 4,
                            spaceBetween: 33
                        },
                    },
                });
            }

            $('.js_slider-products-slider').each(function () {
                let elt = this;
                if ($(elt).find('.item').length > 4) {
                    initSliderProductsSlider(elt);
                } else if ($(elt).find('.item').length > 3) {
                    if ($(window).width() < 961) {
                        initSliderProductsSlider(elt);
                    }
                } else if ($(elt).find('.item').length > 2) {
                    if ($(window).width() < 601 ) {
                        initSliderProductsSlider(elt);
                    }
                }
            });


            // Advices list
            if (windowWidth <= 1024) {
                $('.js_slider-advices-list1').each(function () {
                    let elt = this;
                    if ($(elt).find('.item').length > 1) {
                        new Swiper(elt, {
                            loop: true,
                            speed: 750,
                            slidesPerView: 'auto',
                            spaceBetween: 28,
                        });
                    }
                });
            }


            // Experts slider
            function initSliderExpertsSlider (elt, index) {
                new Swiper(elt, {
                    loop: true,
                    speed: 750,
                    slidesPerView: 1,
                    spaceBetween: 40,
                    navigation: {
                        nextEl: '.js_experts-slider-btn-next.index-' + index,
                        prevEl: '.js_experts-slider-btn-prev.index-' + index,
                    },
                    pagination: {
                        el: '.slider-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    breakpoints: {
                        601: {
                            slidesPerView: 2,
                            spaceBetween: 33
                        },
                        961: {
                            slidesPerView: 3,
                            spaceBetween: 33
                        },
                    },
                });
            }

            $('.js_slider-experts-slider').each(function (index) {
                let elt = this;
                $(elt).siblings('.js_experts-slider-btn-prev, .js_experts-slider-btn-next').addClass('index-' + index);
                if ($(elt).find('.item').length > 3) {
                    initSliderExpertsSlider(elt, index);
                } else if ($(elt).find('.item').length > 2) {
                    if ($(window).width() < 961) {
                        initSliderExpertsSlider(elt, index);
                    }
                } else if ($(elt).find('.item').length > 1) {
                    if ($(window).width() < 601 ) {
                        initSliderExpertsSlider(elt, index);
                    }
                }
            });


            // Form
            $('.module-form .ginput_container_fileupload').each(function (index, el) {
                $(el).attr('data-label', $(this).next('.gfield_description').html());
            });
            $('.module-form .ginput_container_fileupload input').on('change', function (e) {
                let fileName = e.target.value.split('\\').pop();
                let $el = $(this).closest('.ginput_container_fileupload');
                if (fileName == '') {
                    $el.attr('data-label', $(this).closest('.ginput_container_fileupload').next('.gfield_description').html())
                } else {
                    $el.attr('data-label', fileName);
                }
            });

        });

        const searchWidget = new evermapsSearch();

        ajaxExperts.init();
        menuMobile.init();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js